export default "__VITE_ASSET__D5s_iweY__"